import { Fn_activeAxios } from "function/FnConfig";
import {
  NaverBizItemReq,
  NaverBizItemRes,
  NaverBizItemUpdateReq,
  NaverConnectReq,
  NaverDisconnectReq,
  NaverLoginReq,
  NaverLoginRes,
  NaverShopSearchReq,
  NaverShopSearchRes,
} from "./api.type";

// 네이버 로그인
export const postNaverLogin = async (
  rootStore: any,
  payload: NaverLoginReq
): Promise<API.DefaultResponse<NaverLoginRes>> => {
  const api = Fn_activeAxios(rootStore, { needAuth: true });
  const response = await api.post(`/gate/agency/naver/auth/login/id`, payload);
  return response.data;
};

// 네이버 매장 검색
export const getNaverShopSearch = async (
  rootStore: any,
  payload: NaverShopSearchReq
): Promise<API.DefaultResponse<NaverShopSearchRes>> => {
  const api = Fn_activeAxios(rootStore, { needAuth: true, naverAuth: true });

  const { shopCd, ...queryParams } = payload;
  const response = await api.get(`/gate/agency/naver/shops/${payload.shopCd}`, { params: queryParams });
  return response.data;
};

// 네이버 연동 해제
export const postNaverDisconnect = async (
  rootStore: any,
  payload: NaverDisconnectReq
): Promise<API.DefaultResponse<string>> => {
  const api = Fn_activeAxios(rootStore, { needAuth: true, naverAuth: true });
  const response = await api.post(`/gate/agency/naver/shops/${payload.shopCd}/${payload.businessId}/disconnect`);
  return response.data;
};

// 네이버 연동
export const postNaverConnect = async (
  rootStore: any,
  payload: NaverConnectReq
): Promise<API.DefaultResponse<string>> => {
  const api = Fn_activeAxios(rootStore, { needAuth: true, naverAuth: true });
  const response = await api.post(`/gate/agency/naver/shops/${payload.shopCd}/${payload.businessId}/connect`);
  return response.data;
};

// 주문 유형 조회
export const getNaverBizItem = async (
  rootStore: any,
  payload: NaverBizItemReq
): Promise<API.DefaultResponse<NaverBizItemRes>> => {
  const api = Fn_activeAxios(rootStore, { needAuth: true, naverAuth: true });
  const response = await api.get(`/gate/agency/naver/biz-items/${payload.shopCd}/${payload.businessId}`);
  return response.data;
};

// 주문 유형 수정
export const patchNaverBizItem = async (
  rootStore: any,
  payload: NaverBizItemUpdateReq
): Promise<API.DefaultResponse<string>> => {
  const api = Fn_activeAxios(rootStore, { needAuth: true, naverAuth: true });
  const { shopCd, businessId, ...body } = payload;

  const response = await api.patch(`/gate/agency/naver/biz-items/${payload.shopCd}/${payload.businessId}`, body);
  return response.data;
};
